export class BuddyWorkShadowDetailModel implements IBuddyWorkShadowDetailModel {

  constructor(data?: IBuddyWorkShadowDetailModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(Data?: any) {
  }

  static fromJS(data: any): BuddyWorkShadowDetailModel {
    data = typeof data === 'object' ? data : {};
    let result = new BuddyWorkShadowDetailModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    return data;
  }
}

export interface IBuddyWorkShadowDetailModel {
}